<template>
  <div>
    <span v-for="option in options" :key="option" class="option" :class="[{ active: split === option }, `option--${option}`]" @click.stop.prevent="update(option)"></span>
  </div>
</template>

<script>
  export default {
    props: ['split'],
    
    data() {
      return {
        options: ['default', 'bottom']
      }
    },

    methods: {
      update(option) {
        this.$emit('update:split', option);
      }
    }
  }
</script>

<style scoped>
  .option.active:before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 1px solid #000;
  }

  .option {
    position: relative;
    display: inline-block;

    height: 1em;
    width: 1em;
    margin: 2px;
    border: 1px solid #fff;

    margin-right: 0.35em;
  }

  .option--default {
    background: #ccc;
  }

  .option--bottom {
    background: #333;
  }

  .option--bottom:after {
    content: '';

    position: absolute;
    top: calc(50% - 1px);
    bottom: 1px;
    left: 1px;
    right: 1px;
    background: #ccc;
  }
</style>